import React from 'react';
import { useTranslation } from '../../../i18n';

export type HouseRunTaskCategory = 'photo' | 'search' | 'count' | 'funny' | 'teamwork';

export interface HouseRunTask {
  text: string;
  category: HouseRunTaskCategory;
}

const CATEGORY_ICONS: Record<HouseRunTaskCategory, string> = {
  photo: '📸',
  search: '🔍',
  count: '🔢',
  funny: '😂',
  teamwork: '🤝',
};

export interface HouseRunTaskCardProps {
  task: HouseRunTask;
  teamId?: 'A' | 'B';
}

export const HouseRunTaskCard: React.FC<HouseRunTaskCardProps> = ({ task, teamId }) => {
  const { t } = useTranslation();
  const icon = CATEGORY_ICONS[task.category];

  return (
    <div
      style={{
        background: 'rgba(255, 255, 255, 0.08)',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        borderRadius: '1rem',
        padding: '1.25rem',
        textAlign: 'center',
      }}
    >
      {teamId && (
        <div style={{ fontSize: '0.8rem', opacity: 0.7, marginBottom: '0.5rem' }}>
          {t('gameplay.houseRun.teamTask', { team: teamId })}
        </div>
      )}
      <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>{icon}</div>
      <p style={{ fontSize: '1.15rem', margin: 0, lineHeight: 1.4, fontWeight: 600 }}>{task.text}</p>
    </div>
  );
};
